var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1240_1462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1240_1462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 13.5V4.33125L4.95 7.25625L3.375 5.625L9 0L14.625 5.625L13.05 7.25625L10.125 4.33125V13.5H7.875ZM2.25 18C1.63125 18 1.10156 17.7797 0.660938 17.3391C0.220313 16.8984 0 16.3688 0 15.75V12.375H2.25V15.75H15.75V12.375H18V15.75C18 16.3688 17.7797 16.8984 17.3391 17.3391C16.8984 17.7797 16.3688 18 15.75 18H2.25Z",
    fill: "#122961"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.90515d29ca3c120d2c70544ed0e1639d.svg";
export { ForwardRef as ReactComponent };